<script setup>
import Tr from '@/i18n/translation';
import { useRouter } from 'vue-router';
import { useStateStore } from '@/stores/state.store';

const props = defineProps({
  mainColor: {
    type: String,
    required: true,
  },
  backgroundColor: {
    type: String,
    required: true,
  },
  store: {
    type: Object,
    required: true,
  },
});

const router = useRouter();
const stateStore = useStateStore();

function toggleLanguage(lang) {
  if (Tr.currentLocale === lang) {
    return;
  }

  Tr.switchLanguage(lang);
  props.store.tryGetLangDataWithImages(lang);

  const currentPath = router.currentRoute.value.path;
  const pathSegments = currentPath.split('/');
  pathSegments.shift();
  if (Tr.supportedLocales.includes(pathSegments[0])) {
    pathSegments.shift();
  }
  pathSegments.unshift(lang);
  const modifiedPath = '/' + pathSegments.join('/');
  router.replace({ path: modifiedPath });
}
</script>

<template>
  <div v-if="stateStore.isMultiLang" class="lang">
    <button
      v-for="locale in stateStore.getCommonData.langList"
      :key="locale"
      type="button"
      class="lang-button"
      :class="{ active: Tr.currentLocale === locale }"
      @click="toggleLanguage(locale)"
    >
      {{ locale.toUpperCase() }}
    </button>
  </div>
</template>

<style lang="scss" scoped>
.lang {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 10;
  width: auto;
  color: v-bind(mainColor);
  background-color: v-bind(backgroundColor);
  display: flex;
  gap: 15px;
  flex-direction: row;
  justify-content: end;
  align-items: end;
  padding: 10px;
  padding-right: 25px;
  border-radius: 0 0 0 10px;

  .lang-button {
    font-size: 1em;
    font-weight: 700;
    transition: ease all 1s;
    position: relative;
    text-decoration: none;
    display: inline-block;

    &:hover {
      cursor: pointer;
    }

    &::before,
    &::after {
      content: '';
      position: absolute;
      width: 0;
      height: 2px;
      bottom: 0;
      background-color: v-bind(mainColor);
      transition: width 0.3s ease;
    }

    &::before {
      left: 50%;
      transform: translateX(-50%);
    }

    &::after {
      right: 50%;
      transform: translateX(50%);
    }

    &:hover::before,
    &:hover::after {
      width: 100%;
    }
  }

  .active {
    &::before,
    &::after {
      width: 100%;
    }
  }
}
</style>
